import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';

import { TipService } from './service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RxIconModule } from '@nrwl/rx-icon';

@Component({
  selector: 'rx-tip',
  templateUrl: './rx-tip.component.html',
  styleUrls: ['./rx-tip.component.scss'],
  imports: [CommonModule, FormsModule, RxIconModule],
})
export class RxTipComponent implements OnInit, OnChanges {
  @Input()
  public id = 'item' + Math.random().toString(36).substring(2);

  @Input() public set dark(value) {
    this.isDark = value;
  }

  @Input()
  public showClose = true;

  @Input()
  public tipTemplate: TemplateRef<any> | null = null;

  @Output()
  public close: EventEmitter<void> = new EventEmitter<void>();

  @HostBinding('class.dark') public isDark = false;
  @HostBinding('class.dn') public isHidden = false;

  constructor(public tipService: TipService) {}

  public ngOnInit() {}

  public onClose() {
    if (this.id) {
      this.tipService.saveTip(this.id);
    }

    this.isHidden = true;
    this.close.emit();
  }

  public ngOnChanges() {
    if (this.id) {
      this.isHidden = this.tipService.checkTip(this.id);
    }
  }
}
